module.exports = __webpack_public_path__ + "img/9788937484421.33f2bc56.jpg";